/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { DtpContentContainer, DtpNoContent } from 'dtp-react-components';
import {
  Table,
} from '../../components/index';
import {
  doGet,
} from '../../utils/requests';
import * as listUtils from '../../utils/listsSelect';
import * as constantes from '../../utils/constants';
import FiltroPesquisa from './FiltroPesquisa';
import './css/ConsultaFilaGet.css';
import { manterApenasFiltro } from '../../utils/helpers';
import ModalRetornoFilaGet from './ModalRetornoFilaGet';
import RelatorioFilaGet from './exportacao-csv/RelatorioFilaGet';

class ConsultaFilaGet extends Component {
  constructor(props) {
    super(props);
    this.state = {
      listaRegistrosFiltrada: null,
      listaRegistrosIndexada: [],
      registroVindoDoRequest: null,
      showNoContent: false,
      listaRegistrosIndexadaAtualizada: false,
      estadoTabela: {
        quantidadeTotalResultados: 0,
        resultadosPorPagina: 10,
        paginaAtual: 1,
      },
      filtrosPesquisa: {},
      showDadosRetornoModal: false,
    };
  }

  componentDidMount() {
    manterApenasFiltro('');
  }

  componentDidUpdate(prevProps) {
    // Apenas repete consulta se parametro da url for alterado
    if (this.props.match.params.tipoConsulta !== prevProps.match.params.tipoConsulta) {
      this.preparaNovaConsulta();
    }
  }

  getTipoConsulta = () => (
    this.props.match.params.tipoConsulta
  )

  preparaNovaConsulta = () => {
    const estadoTabela = {
      quantidadeTotalResultados: 0,
      resultadosPorPagina: 10,
      paginaAtual: 1,
    };
    this.setState({
      listaRequerimentosFiltrada: null,
      estadoTabela,
    }, this.realizaConsulta());
  }

  lotacao = this.props.auth.userData.lotacoes[0];

  realizaConsulta = (filtrosPesquisa) => {
    let filtrosConsulta = {};
    if (filtrosPesquisa) {
      filtrosConsulta = this.montaFiltros(filtrosPesquisa);
    }

    filtrosConsulta['tipo-consulta'] = this.getTipoConsulta();

    // Copiar atributos além do filtro
    const atributosConsulta = this.verificaAtributosParaConsulta();
    if (atributosConsulta) {
      if (filtrosConsulta.estado === undefined) {
        filtrosConsulta.estado = atributosConsulta.estados;
      }
      filtrosConsulta.participacao = atributosConsulta.tipoParticipacao;
      filtrosConsulta['atributo-ordenacao'] = atributosConsulta.campoOrdenacao;
      if (atributosConsulta.filtroTipoExigencias) {
        filtrosConsulta['tipo-exigencia'] = atributosConsulta.filtroTipoExigencias;
      }
    }
    this.setState({ ...this.state, filtrosConsulta }, this.executaConsulta);
  }

  executaConsulta = () => {
    if (Object.entries(this.state.filtrosConsulta).length !== 0) {
      const { resultadosPorPagina } = { ...this.state.estadoTabela };
      const primeiroItem = (this.state.estadoTabela.paginaAtual - 1) * resultadosPorPagina;
      doGet(
        'fila-do-get',
        this.tratarSucesso,
        this.tratarErro,
        {
          ...this.state.filtrosConsulta,
          'start-position': primeiroItem,
          'max-results': resultadosPorPagina,
        },
      );
    } else {
      this.setState({ listaRegistrosIndexada: [], listaRegistrosIndexadaAtualizada: true });
    }
  }

  undefinedToVazio = (valor) => {
    const retorno = '';
    if (valor === undefined) {
      return retorno;
    }
    return valor;
  }

  montaFiltros = (atributosPesquisa) => {
    let atributos = {};
    // filtro é a caixa de texto que pesquisa por cpf, nit e nb
    let filtroValido = atributosPesquisa.filtro;
    if (filtroValido === null) {
      filtroValido = '';
    }
    atributos = { ...atributos, filtro: filtroValido };

    if (atributosPesquisa.idProtocolo) {
      const valor = this.undefinedToVazio(atributosPesquisa.idProtocolo);
      let valorFinal = '';
      if (valor === '') {
        atributos = { ...atributos, idProtocolo: valor };
      } else {
        valorFinal = atributosPesquisa.idProtocolo.trim();
        atributos = { ...atributos, idProtocolo: valorFinal };
      }
    }

    if (atributosPesquisa.pendenteEnvio) {
      atributos = { ...atributos, pendenteEnvio: atributosPesquisa.pendenteEnvio };
    }

    if (atributosPesquisa.mensagemRetorno) {
      const valor = this.undefinedToVazio(atributosPesquisa.mensagemRetorno);
      let valorFinal = '';
      if (valor === '') {
        atributos = { ...atributos, mensagemRetorno: valor };
      } else {
        valorFinal = atributosPesquisa.mensagemRetorno.trim();
        atributos = { ...atributos, mensagemRetorno: valorFinal };
      }
    }

    if (atributosPesquisa.bodyEnvio) {
      const valor = this.undefinedToVazio(atributosPesquisa.bodyEnvio);
      let valorFinal = '';
      if (valor === '') {
        atributos = { ...atributos, bodyEnvio: valor };
      } else {
        valorFinal = atributosPesquisa.bodyEnvio.trim();
        atributos = { ...atributos, bodyEnvio: valorFinal };
      }
    }

    const { resultadosPorPagina } = { ...this.state.estadoTabela };
    if (atributosPesquisa.cliqueiNoBotao === 1) {
      this.state.estadoTabela.paginaAtual = 1;
    }
    const primeiroItem = (this.state.estadoTabela.paginaAtual - 1) * resultadosPorPagina;
    atributos = { ...atributos, 'max-results': resultadosPorPagina };
    atributos = { ...atributos, 'start-position': primeiroItem };

    return atributos;
  }

  verificaAtributosParaConsulta = () => {
    if (this.getTipoConsulta()) {
      return constantes.estadosParaConsulta[this.getTipoConsulta()];
    }
    return null;
  }

  tratarSucesso = (response) => {
    let quantidadeTotalResultados = 0;
    if (response.headers['content-range']) {
      const { headers } = { ...response };
      // eslint-disable-next-line
      quantidadeTotalResultados = headers['content-range'].split('/')[1];
    }
    const { estadoTabela } = { ...this.state };
    estadoTabela.quantidadeTotalResultados = quantidadeTotalResultados;
    if (response.data === '') {
      this.setState({
        showNoContent: false,
        listaRegistrosIndexada: [],
        listaRegistrosIndexadaAtualizada: true,
        estadoTabela,
      });
    } else {
      this.setState({
        showNoContent: false,
        listaRegistrosIndexada: response.data,
        listaRegistrosIndexadaAtualizada: true,
        estadoTabela,
      });
    }
  };

  /**
   * Trata filtros na lista que veio do servidor (Componente FiltroPesquisa)
   */
  tratarFiltroNaLista = (listaRegistrosFiltrada) => {
    this.setState({ listaRegistrosFiltrada, listaRegistrosIndexadaAtualizada: false });
  }

  tratarErro = (error) => {
    if (error) {
      const { data } = { ...error };
      if (error.status) {
        if (error.status === 404) {
          this.setState({
            showNoContent: true,
            noContentPrimaryMessage: 'Requerimento não encontrado para o protocolo informado.',
            noContentSecondaryMessage: 'Informe um protocolo válido.',
          });
        } else {
          this.setState({
            showNoContent: true,
            noContentPrimaryMessage: `${data.mensagem}`,
            noContentSecondaryMessage: `${data.descricao}`,
          });
        }
      } else {
        this.setState({
          showNoContent: true,
          noContentPrimaryMessage: 'Ocorreu uma falha de comunicação com o serviço de compensação previdenciária.',
          noContentSecondaryMessage: 'Tente novamente mais tarde.',
        });
      }
    }
  }

  handleChange = (e, name) => {
    this.setState({
      ...this.state,
      [name]: e,
    });
  }

  addTipoRequerimentoLabel = valor => (
    valor !== undefined ? (valor.substring(0, 80)) : valor
  )

  showDadosRetornoModal = (row) => {
    this.setState({
      showDadosRetornoModal: !this.state.showDadosRetornoModal,
      retorno: row,
    });
  }

  handleModalDadosRetorno = () => {
    this.setState({
      showDadosRetornoModal: !this.state.showDadosRetornoModal,
    });
  }

  addLinkRetorno = (valor, row) => (
    <React.Fragment>
      {valor !== undefined ?
        (<a href="#" onClick={() => this.showDadosRetornoModal(row)}>{valor.substring(0, 80)}</a>) : (valor)}
    </React.Fragment>
  )

  addTipoEstadoLabel = (tipo) => {
    if (tipo === 15) {
      return 'Exigência/indeferido';
    }

    if (tipo === 16) {
      return 'Indeferimento ratificado';
    }

    return listUtils.getObject(listUtils.tiposEstado, tipo).label;
  }

  colunasDefault = [
    {
      id: 'idProtocolo',
      label: 'Protocolo',
    }, {
      id: 'dataEnvioGet',
      label: 'Data Envio',
    }, {
      id: 'dataRetornoComprev',
      label: 'Data Retorno',
    }, {
      id: 'url',
      label: 'URL',
      dataFormat: this.addLinkRetorno,
    }, {
      id: 'bodyEnvio',
      label: 'Body envio',
      dataFormat: this.addLinkRetorno,
    }, {
      id: 'retorno',
      label: 'Retorno ',
      dataFormat: this.addLinkRetorno,
    }, {
      id: 'pendente',
      label: 'Pendente Envio GET',
      dataFormat: this.addTipoRequerimentoLabel,
    }];

  montaColunas = () => {
    const requerimentosExigenciaTableHeader = this.colunasDefault.slice();
    return requerimentosExigenciaTableHeader;
  }

  defineListaParaTabela = () => {
    if (this.state.listaRegistrosFiltrada !== null) {
      return this.state.listaRegistrosFiltrada;
    }
    return this.state.listaRegistrosIndexada;
  }

  alterarPagina = (pagina, page) => {
    const { estadoTabela } = { ...this.state };
    if (pagina === 0) {
      estadoTabela.paginaAtual = 1;
    } else {
      estadoTabela.paginaAtual = pagina;
    }

    if (page) {
      estadoTabela.resultadosPorPagina = page;
    }

    this.setState({
      estadoTabela,
      ...this.state,
    }, this.realizaConsulta());
  }

  alterarResultadosPorPagina = (resultadosPorPagina) => {
    const { estadoTabela } = { ...this.state };
    estadoTabela.resultadosPorPagina = resultadosPorPagina;
    this.setState({
      estadoTabela,
      ...this.state,
    }, this.realizaConsulta());
  }

  render() {
    const options = {
      noDataText: 'Nenhum elemento da Fila Get a ser exibido',
      hideSizePerPage: false,
      onPageChange: this.alterarPagina,
      page: this.state.estadoTabela.paginaAtual,
      sizePerPage: this.state.estadoTabela.resultadosPorPagina,
      sizePerPageList: listUtils.linhasPorPagina,
    };
    const fetchInfo = {
      dataTotalSize: this.state.estadoTabela.quantidadeTotalResultados,
    };
    const requerimentosExigenciaTableHeader = this.montaColunas();

    return (
      this.state.showNoContent ? (
        <DtpNoContent
          primarylabel={this.state.noContentPrimaryMessage}
          secondarylabel={this.state.noContentSecondaryMessage}
          show={this.state.showNoContent}
        />
      ) : (
        <DtpContentContainer>
          <FiltroPesquisa
            handleSearchFilter={this.realizaConsulta}
            handleChangeList={this.tratarFiltroNaLista}
            destinatarios=""
            list={this.state.listaRegistrosIndexada}
            tipoConsulta={this.getTipoConsulta()}
            listaRegistrosIndexadaAtualizada={this.state.listaRegistrosIndexadaAtualizada}
          />
          {((this.state.listaRegistrosIndexada) && (this.state.listaRegistrosIndexada.length > 0)) ?
            <RelatorioFilaGet filtrosConsulta={this.state.filtrosConsulta} />
          : '' }
          <Table
            legend={this.state.estadoTabela.quantidadeTotalResultados === 0 ?
              'Consulta Fila de Envios ao GET' :
              `Consulta Fila de Envios Get -  ${this.state.estadoTabela.quantidadeTotalResultados} registro(s) encontrado(s)`}
            bordered
            fetchInfo={fetchInfo}
            data={this.defineListaParaTabela()}
            options={options}
            listaTableHeader={requerimentosExigenciaTableHeader}
            pagination
            remote
          />
          {this.state.showDadosRetornoModal ? (
            <ModalRetornoFilaGet
              {...this.props}
              estadoFormulario={this.state}
              retornoFilaGet={this.state.retorno}
              handleModal={() => this.handleModalDadosRetorno('showDadosRetornoModal')}
              showModal={this.state.showDadosRetornoModal}
            />
          ) : ''}
        </DtpContentContainer>
      )
    );
  }
}

ConsultaFilaGet.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      idProtocolo: PropTypes.string,
      tipoConsulta: PropTypes.string,
    }),
  }),
  history: PropTypes.shape({
    push: PropTypes.func,
  }).isRequired,
  auth: PropTypes.shape({
    userData: PropTypes.object,
    checkPermission: PropTypes.func,
  }).isRequired,
};

ConsultaFilaGet.defaultProps = {
  match: null,
};

export default ConsultaFilaGet;



// WEBPACK FOOTER //
// ./src/pages/consultas/ConsultaFilaGet.jsx